import React, { useEffect } from 'react';
import styles from './TenthScreen.module.css';
import ScrollReveal from 'scrollreveal';
import Button from '../SecondReceptionistComponents/button/Button';

const TenthScreenRec = () => {
  useEffect(() => {
    ScrollReveal().reveal(`.${styles.subtitle}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
    });

    ScrollReveal().reveal(`.${styles.description}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
      delay: 100,
    });

    ScrollReveal().reveal(`.${styles.title}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
      delay: 200,
    });

    ScrollReveal().reveal(`.${styles.option}`, {
      duration: 1000,
      distance: '50px',
      origin: 'bottom',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
      interval: 200,
    });

    ScrollReveal().reveal(`.${styles.urgencyText}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
      delay: 400,
    });
  }, []);

  return (
    <section className={styles.container}>
      <div className={styles.contentWrapper}>
        <p className={styles.subtitle}>בואי נהיה כנות</p>
        
        <div className={styles.description}>
          שנינו יודעות שאם תצאי מהדף הזה עכשיו בלי לעשות שום דבר את תחשבי על הנושא עוד כמה שעות ויתחילו לצוף לך כל הסיבות בעולם ל״למה לא לעשות כלום״ ולמה להמשיך להשאר באזור הנוח והבטוח
        </div>
        
        <div className={styles.title}>יש לך 2 אפשרויות</div>
        
        <div className={styles.optionContainer}>
          <div className={styles.option}>
            <div className={styles.optionNumber}>1</div>
            <div className={styles.optionTitle}>להמשיך במסלול הקיים</div>
            <div className={styles.optionText}>
              להמשיך להשקיע את כל הלב והנשמה בעסקים של אחרים, להסתפק במשכורת קבועה שלא גדלה, לבקש אישורים על חופשים ולהרגיש שאת "בורג במערכת" שלא מקבל את ההערכה שמגיעה לו.
            </div>
          </div>

          <div className={styles.option}>
            <div className={styles.optionNumber}>2</div>
            <div className={styles.optionTitle}>לצאת לדרך חדשה</div>
            <div className={styles.optionText}>
              לקחת את כל הכישרון שיש לך בידיים, לבנות עסק רווחי של 5 ספרות בתנאים שלך, לעבוד מהבית או מהקפה, להיות הבוסית של עצמך ולהתחיל להרוויח בדיוק כמה שאת שווה.
            </div>
          </div>
        </div>

        <div className={styles.urgencyText}>
          "הזמן הכי טוב להתחיל היה לפני שנה. הזמן השני הכי טוב הוא עכשיו"
        </div>
        
        <Button text="קרן, אני רוצה לצאת לדרך חדשה" />
      </div>
    </section>
  );
};

export default TenthScreenRec;
